import type { OverrideAction } from "./AffiliateLedgerCard";

export const ACTION_LABEL: Record<OverrideAction, string> = {
  approve: "Approve early",
  reverse: "Reverse",
  forfeit: "Forfeit",
  mark_paid: "Mark paid",
};

export const ACTION_NEEDS_NOTES: Record<OverrideAction, boolean> = {
  approve: false,
  reverse: false,
  forfeit: true,
  mark_paid: true,
};
